export const DEFAULT_THEME = {
    primaryColor: '#1D4ED8', secondaryColor: '#64748B', accentColor: '#0EA5E9',
    logoUrl: '/logo-default.svg', fontFamily: 'Inter',
};
export function applyTenantTheme(theme) {
    const t = { ...DEFAULT_THEME, ...theme };
    const r = document.documentElement;
    r.style.setProperty('--tenant-primary', t.primaryColor);
    r.style.setProperty('--tenant-secondary', t.secondaryColor);
    r.style.setProperty('--tenant-accent', t.accentColor);
    if (t.logoUrl)
        r.style.setProperty('--tenant-logo-url', `url(${t.logoUrl})`);
    if (t.fontFamily && t.fontFamily !== 'Inter') {
        r.style.setProperty('--tenant-font', `'${t.fontFamily}', var(--font-sans)`);
        const id = `gf-${t.fontFamily.replace(/\s+/g, '-').toLowerCase()}`;
        if (!document.getElementById(id)) {
            const link = Object.assign(document.createElement('link'), {
                id, rel: 'stylesheet',
                href: `https://fonts.googleapis.com/css2?family=${encodeURIComponent(t.fontFamily)}:wght@400;500;600;700&display=swap`
            });
            document.head.appendChild(link);
        }
    }
}
export function clearTenantTheme() {
    ;
    ['--tenant-primary', '--tenant-secondary', '--tenant-accent', '--tenant-logo-url', '--tenant-font']
        .forEach(p => document.documentElement.style.removeProperty(p));
}
//# sourceMappingURL=tenant-theme.js.map